import React from 'react';
import { useTranslation } from 'react-i18next';

interface CustomProductsCellProps {
    [key: string]: any;
    isLocked?: boolean;
}

const AccountState: React.FC<CustomProductsCellProps> = ({ isLocked })=> {
    const { t } = useTranslation();

    return isLocked ? t('locked') : t('unlocked');
};

export default AccountState;
